import { render, staticRenderFns } from "./FullScreenPresenter.vue?vue&type=template&id=4ac3339b&"
import script from "./FullScreenPresenter.js?vue&type=script&lang=js&"
export * from "./FullScreenPresenter.js?vue&type=script&lang=js&"
import style0 from "./FullScreenPresenter.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports